import { useEffect, useState } from 'react'
import { Arr } from '../../../helpers/Arr'
import './Sections.scss'
import { IFormFieldOption } from '../FormBuilder/FormBuilder'
  
interface ICheckboxInputProps {
  name: string
  title: string
  className?: string
  defaultValue?: string
  fields: IFormFieldOption[]
  hidden?: boolean // Section is hidden = deactive
  disabled: boolean
  handleChange: (name: string, value: string, valid: boolean) => void
}

export const CheckboxSection = (props: ICheckboxInputProps) => {
  const [selectedValue, setSelectedValue] = useState<string[]>([])

  useEffect(() => {
    setSelectedValue(props.defaultValue ? props.defaultValue.split(',') : [])

    if (props.defaultValue) {
      props.handleChange(props.name, props.defaultValue, true)
    }
  }, [])

  useEffect(() => {
    if (props.hidden) {
      dispose()
    }
  }, [props.hidden])

  const valueChanged = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (props.disabled) {
      return
    }
    
    let newSelectedValue = [ ...selectedValue ]

    const { value } = event.currentTarget
    const selected = !!newSelectedValue.find(v => v === value)

    if (selected) {
      newSelectedValue = newSelectedValue.filter(v => v !== value)
    } else {
      newSelectedValue.push(value)
    }

    props.handleChange(props.name, newSelectedValue.join(','), true)
    setSelectedValue(newSelectedValue)
  }

  const dispose = () => {
    const value: string[] = []

    props.handleChange(props.name, '', true)
    setSelectedValue(value)
  }

  return (
    <div className={'fade disabled ' + (!props.hidden ? 'in' : 'out')}>
      <div className="box-title center">
        {props.title}
      </div>
      <div className={'thirdChoiceList firstChoiceList control-group ' + (props.className ?? '') + ' ' + (Arr.any(selectedValue) ? 'selected' : '')}>
        {props.fields.map((field, i) => !field.hidden && (
          <label className={'control control-checkbox ' + (selectedValue.find(value => value === field.value) ? 'selected' : '')} key={i}>
            <input type="checkbox"
              value={field.value} 
              name={props.name} 
              onChange={valueChanged.bind(this)} 
              checked={!!selectedValue.find(value => value === field.value)}
            />
            <div className="control_indicator"></div>
            <div className='checkLabel'>
              {field.icon && (
                <i className={field.icon} />
              )}
              {field.label}
            </div>
          </label>
        ))}
      </div>
    </div>
  )
}